import AbstractVertical from './AbstractVertical'

export default class OnDemand extends AbstractVertical {

  readonly name: string = 'on_demand'
  readonly title: string = 'On Demand'
  readonly color: string = '#b85143'
  readonly sortWeight: number = 100

  readonly supportedFeatures: string[] = [
    'showOnRateManagementCalendar',
    'limitedByWeekday',
    'showOnUniversalInventoryCalendar',
    'startAndEndTimes',
    'tieredRates',
  ]

}
